import { isPaidSubscription, type SubscriptionLike } from '@/lib/quota/isPaidSubscription';

interface PixRecoverySubscription extends SubscriptionLike {
  payment_provider?: string | null;
  past_due?: boolean | null;
  cancellation_at?: string | null;
  pagarme_last_order_id?: string | null;
}

export interface PixRecoveryState {
  isPastDue: boolean;
  canRecover: boolean;
  shouldAutoPrompt: boolean;
  graceDeadline: string | null;
}

/**
 * A PIX grace deadline is not a cancellation. Keep recovery available while
 * the paid Pagarme subscription is past_due, even after an older QR/order has
 * expired and pagarme_last_order_id has been cleared.
 */
export function derivePixRecoveryState(
  subscription: PixRecoverySubscription | null | undefined,
): PixRecoveryState {
  const isPastDue = subscription?.payment_provider === 'pagarme'
    && subscription?.past_due === true;
  const canRecover = isPastDue && isPaidSubscription(subscription);

  return {
    isPastDue,
    canRecover,
    shouldAutoPrompt: canRecover,
    graceDeadline: canRecover ? subscription?.cancellation_at ?? null : null,
  };
}

